module.exports = __webpack_public_path__ + "static/media/50women.e035d182.svg";